import { Link } from 'react-router-dom';

const plan = {
  name: 'Abonnement CotIdel',
  price: '5.99',
  period: 'mois',
  description: 'Toutes les intelligences, sans limite. Un seul prix, tout inclus.',
  features: [
    'Analyses de cotation illimitées',
    'Les 8 intelligences activées',
    'Veille réglementaire',
    'Intelligence prédictive',
  ],
  cta: 'Créer mon compte gratuit',
};

export default function PricingSection() {
  return (
    <section id="pricing" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14 animate-on-scroll">
          <span className="text-xs font-semibold text-accent-600 uppercase tracking-wider">Tarif</span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mt-3 mb-4">
            Un seul prix, tout inclus
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            Pas de plans complexes, pas de limitations cachées. Un seul abonnement qui débloque
            l&apos;intégralité des fonctionnalités. 2 cotations offertes à la création de votre compte.
          </p>
        </div>

        <div className="max-w-md mx-auto">
          <div className="relative rounded-lg p-8 bg-primary-500 text-white">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2">
              <span className="px-4 py-1 bg-accent-500 text-background-950 text-xs font-bold rounded-full whitespace-nowrap">
                2 cotations gratuites
              </span>
            </div>

            <h3 className="text-lg font-bold font-heading mb-1">
              {plan.name}
            </h3>
            <p className="text-xs text-white/70 leading-relaxed mb-6">
              {plan.description}
            </p>

            <div className="mb-6">
              <span className="text-4xl md:text-5xl font-bold font-heading">
                {plan.price}€
              </span>
              <span className="text-sm text-white/70 ml-1">
                /{plan.period}
              </span>
            </div>

            <ul className="space-y-3 mb-8">
              {plan.features.map((feat, fidx) => (
                <li key={fidx} className="flex items-start gap-2.5">
                  <div className="w-4 h-4 flex items-center justify-center rounded-full bg-white/20 text-white mt-0.5 flex-shrink-0">
                    <i className="ri-check-line text-xs"></i>
                  </div>
                  <span className="text-xs text-white/90">
                    {feat}
                  </span>
                </li>
              ))}
            </ul>

            <Link
              to="/auth/register"
              className="block w-full text-center py-3.5 rounded-md text-sm font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap bg-white text-primary-700 hover:bg-white/90"
            >
              {plan.cta}
            </Link>

            <p className="text-center text-xs text-white/50 mt-4">
              Sans carte bancaire. Annulez à tout moment.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}